import { IVariation, IVariationDetails } from '~/lib/data-contract';

export const variationDetailsToVariation = (variationDetails: IVariationDetails): IVariation => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { variations, type, ...rest } = variationDetails;

	return { ...rest, type: 'variation' };
};
